<script>
export default {};
</script>

<template>
    <!--START CONOCE-->

    <section class="section pt-5" id="conoce">
        <section class="section section-lg bg-web-desc">
            <div class="bg-overlay2"
                :style="{ 'background-image': 'url(' + require('@/assets/images/ejemplo-7.jpg') + ')', 'background-size': 'cover', 'background-attachment': 'fixed' }">
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <h2 class="text-black-2">¡Tenemos la cobertura indicada <br> para cubrir las necesidades de tu
                            viaje!
                        </h2>
                        <a href="https://public.nhseguros.com/#!policyindividual/index?code=22807&lang=es" target="_blank"
                            class="btn btn-custom btn-rounded margin-t-30 waves-effect waves-light mb-5">Conoce nuestros
                            beneficios</a>
                    </div>
                </div>
            </div>
            <div class="bg-pattern-effect">
                <img src="@/assets/images/bg-pattern.png" alt />
            </div>
        </section>
        <div class="container margin-t-20">
            <h3 align="center"><br>Conoce nuestras pólizas<br></h3>
            <div class="section-title-border margin-t-20"></div>
            <div class="row margin-t-30" style="margin-left: 0px">
                <div class="col-lg-4">
                    <div class="services-box text-center hover-effect">
                        <i class="pe-7s-car text-custom"></i>
                        <h4 class="padding-t-15">Básico</h4>
                        <div class="lis">
                            <ul align="justify">
                                <li>Responsabilidad Civil</li>
                                <li>Asistencia Vial</li>
                                <li>Gastos Médicos</li>
                                <li>Defensa Legal</li><br>
                            </ul>
                        </div>
                        <p class="padding-t-15 text-muted" align="center">*Consulta términos, condiciones y coberturas de
                            tu
                            póliza.</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="services-box text-center hover-effect">
                        <i class="pe-7s-display2 text-custom"></i>
                        <h4 class="padding-t-15">Limitado</h4>
                        <div class="lis">
                            <ul align="justify">
                                <li>Responsabilidad Civil</li>
                                <li>Defensa Legal</li>
                                <li>Gastos Médicos</li>
                                <li>Robo total</li>
                            </ul>
                        </div>
                        <p class="padding-t-15 text-muted" align="center">*Consulta términos, condiciones y coberturas de
                            tu
                            póliza.</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="services-box text-center hover-effect">
                        <i class="pe-7s-piggy text-custom"></i>
                        <h4 class="padding-t-15">Amplio</h4>
                        <div class="lis">
                            <ul align="justify">
                                <li>Responsabilidad Civil</li>
                                <li>Daños Materiales</li>
                                <li>Gastos Médicos</li>
                                <li>Robo total</li>
                            </ul>
                        </div>

                        <p class="padding-t-15 text-muted" align="center">*Consulta términos, condiciones y coberturas de
                            tu
                            póliza.</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="services-box text-center hover-effect">
                        <i class="pe-7s-science text-custom"></i>
                        <h4 class="padding-t-15">Platino</h4>
                        <div class="lis">
                            <ul align="justify">
                                <li>R. Civil por $300,000</li>
                                <li>Robo Parcial/Total</li>
                                <li>Defensa Legal</li>
                                <li>Daños Materiales</li>
                            </ul>
                        </div>
                        <p class="padding-t-15 text-muted" align="center">*Consulta términos, condiciones y coberturas
                            de tu póliza.</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <img src="../assets/images/pyramid.jpg" alt="..." style="max-width: 100%; padding-top: 150px;"
                        class="pi1">
                </div>
                <div class="col-lg-4 consu" style="margin-right: 185px;">
                    <p class="padding-t-15 text-muted3-3" align="center" style="width: 550px;">*Consulta términos,
                        condiciones y coberturas
                        de tu póliza.</p>
                </div>
                <div class="col-lg-4">
                    <img src="../assets/images/pyramid.jpg" alt="..." style="max-width: 100%; padding-top: 150px;">
                </div>
            </div>
        </div>
        <section class="section section-lg bg-web-desc">
            <div class="bg-overlay2"
                :style="{ 'background-image': 'url(' + require('@/assets/images/Cober2-2.jpg') + ')', 'background-size': 'cover', 'background-attachment': 'fixed' }">
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <h2 class="text-black">Más productos para tu seguridad</h2>
                        <div class="section-title-border margin-t-20"></div>
                        <table class="coverage-table2">
                            <tr class="text-black text-center" style="font-size: large;">
                                <th style="width: 33.33%;">
                                    Polizas Blanket
                                </th>
                                <th style="width: 33.33%;">
                                    Driver's License
                                </th>
                            </tr>
                            <tr class="text-black">
                                <td style="width: 33.33%; padding-right: 12px;">
                                    Asegura tus Flotillas empresariales con placa americana destinada a empleados
                                    extranjeros que cruzan o viven en México por cuestiones laborales.
                                </td>
                                <td style="width: 33.33%; padding-left: 12px;">
                                    Para
                                    conductores extranjeros que manejan cualquier vehículo con placa americana o canadiense
                                    en México, sin necesidad de descripción de unidad.
                                </td>
                            </tr>
                            <tr class="text-muted2 text-center">
                                <th style="width: 33.33%;">*Consulta términos, condiciones y coberturas
                                    de tu póliza.</th>
                                <th style="width: 33.33%;">*Consulta términos, condiciones y coberturas
                                    de tu póliza.</th>
                            </tr>
                        </table>

                    </div>
                </div>
            </div>
            <div class="bg-pattern-effect">
                <img src="@/assets/images/bg-pattern.png" alt />
            </div>
        </section>
    </section>
    <!--START CONOCE-->
</template>
<style scoped>
.coverage-table2 {
    width: 80%;
    min-width: 100%;
    margin: 0 auto;
    border-collapse: collapse;
    text-align: justify;
}

td {
    position: relative;
}

.text-muted {
    display: none;
}

@media (max-width: 414px) {

    .coverage-table2,
    .text-muted2 {
        font-size: 85%;
    }

    .text-muted {
        display: block;
    }

    .text-muted3-3,
    .pi1 {
        display: none;
    }

    .container {
        padding-left: 42px
    }
}

@media (max-width: 991px) {
    .text-muted {
        display: block;
    }

    .text-muted3-3,
    .pi1 {
        display: none;
    }
}

@media (max-width: 1199px) {
    .consu {
        width: 280px;
    }

    .text-muted3-3 {
        width: 100px;
    }

}
</style>